module.exports = __webpack_public_path__ + "media/empty-states/attendees-2x-3580330a.png";